import { siteStats, trendingKeywords } from "@/mocks/posts";

interface HeroProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
}

export default function Hero({ searchQuery, onSearchChange }: HeroProps) {
  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    document.getElementById("feed")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const stats = [
    { value: siteStats.clues.toLocaleString("en-US"), label: "条线索" },
    { value: siteStats.discussions.toLocaleString("en-US"), label: "条讨论" },
    { value: siteStats.users.toLocaleString("en-US"), label: "位参与者" },
    { value: `+${siteStats.todayNew}`, label: "今日新增" },
  ];

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20editorial%20background%20with%20layered%20coral%20red%20and%20amber%20organic%20shapes%2C%20subtle%20paper%20grain%20texture%2C%20soft%20directional%20light%2C%20minimalist%20magazine%20cover%20aesthetic%2C%20no%20text&width=1600&height=900&seq=kanliao-hero-01&orientation=landscape"
          alt="99看料 热点线索分享社区的氛围背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75" />
      </div>

      <div className="relative mx-auto flex w-full max-w-container flex-col items-center px-4 md:px-6 py-20 md:py-32 text-center">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-foreground-950/30 px-4 py-1.5 font-label text-xs md:text-sm text-background-100 backdrop-blur">
          <span className="h-1.5 w-1.5 rounded-full bg-accent-400" aria-hidden="true" />
          全网热点 · 线索分享 · 理性讨论
        </span>

        <h1 className="mt-6 max-w-4xl font-heading text-4xl md:text-6xl font-black leading-tight text-background-50">
          99看料 · 把每一条线索都讲清楚
        </h1>

        <p className="mt-6 max-w-2xl text-sm md:text-lg leading-relaxed text-background-100/90">
          欢迎留言评论、投稿爆料或反馈意见。每一条内容下方都可参与讨论，你的补充与看法，可能就是下一条料的线索，一起让信息更完整、更热闹。
        </p>

        <form onSubmit={handleSearch} className="mt-9 w-full max-w-xl" role="search">
          <div className="flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/95 p-1.5 pl-4 focus-within:border-primary-400">
            <i className="ri-search-line text-lg text-foreground-500" aria-hidden="true" />
            <label htmlFor="hero-search" className="sr-only">
              搜索热点线索
            </label>
            <input
              id="hero-search"
              name="keyword"
              type="search"
              value={searchQuery}
              onChange={(event) => onSearchChange(event.target.value)}
              placeholder="搜索你关心的热点、城市或话题"
              className="h-10 w-full bg-transparent font-label text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
            <button
              type="submit"
              className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-5 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              <span className="hidden sm:inline">找线索</span>
              <i className="ri-arrow-right-line text-base sm:hidden" aria-hidden="true" />
            </button>
          </div>
        </form>

        <dl className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-6 md:grid-cols-4">
          {stats.map((item) => (
            <div key={item.label} className="flex flex-col items-center">
              <dt className="order-2 mt-1 font-label text-xs md:text-sm text-background-100/70">{item.label}</dt>
              <dd className="order-1 font-heading text-2xl md:text-3xl font-bold text-background-50">{item.value}</dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="relative border-t border-background-50/15 bg-foreground-950/60 backdrop-blur">
        <div className="mx-auto flex max-w-container items-center gap-4 overflow-hidden px-4 md:px-6 py-3">
          <span className="flex shrink-0 items-center gap-2 font-label text-xs md:text-sm font-medium text-accent-300">
            <i className="ri-fire-line text-base" aria-hidden="true" />
            此刻热议
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-ticker items-center gap-8 whitespace-nowrap">
              {[...trendingKeywords, ...trendingKeywords].map((word, index) => (
                <span key={`${word}-${index}`} className="font-label text-sm text-background-100/85">
                  {word}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}